import { ArrowRight } from "lucide-react";
import { StaggerContainer, StaggerItem } from "@/components/site/Animations";

const STEPS = [
  {
    number: "01",
    title: "Capture",
    description: "Position and qualify team for pursuit. Structure teaming strategy and compliance inputs.",
  },
  {
    number: "02",
    title: "Source",
    description: "Identify, qualify, and structure relationships with suppliers, integrators, and technical partners.",
  },
  {
    number: "03",
    title: "Contract",
    description: "Define scopes, enforceable milestones, and schedules built for disruption and contingency.",
  },
  {
    number: "04",
    title: "Deliver",
    description: "Assure execution with contingencies that hold. Manage contract deliverables and performance.",
  },
  {
    number: "05",
    title: "Coordinate",
    description: "Keep agencies, primes, and vendors aligned throughout program delivery and transitions.",
  },
];

export function WorkflowRail() {
  return (
    <StaggerContainer stagger={0.1} className="grid grid-cols-1 md:grid-cols-5 gap-4 md:gap-3 auto-rows-fr" data-testid="workflow-rail">
      {STEPS.map((step, idx) => (
        <StaggerItem key={step.title} className="flex">
          <div className="relative group flex-1">
            <div className="border border-border rounded-lg p-5 bg-white card-hover flex flex-col h-full">
              <div className="flex items-center gap-2 mb-3">
                <span className="text-xs font-bold text-[hsl(41,47%,61%)]" style={{ fontFamily: 'var(--font-display)' }}>
                  {step.number}
                </span>
                {idx < STEPS.length - 1 && (
                  <ArrowRight className="w-3 h-3 text-muted-foreground hidden md:block absolute -right-3 top-1/2 -translate-y-1/2 z-10" />
                )}
              </div>
              <h3
                className="text-base font-semibold tracking-tight text-foreground mb-2"
                style={{ fontFamily: 'var(--font-display)' }}
              >
                {step.title}
              </h3>
              <p className="text-sm leading-relaxed text-muted-foreground">
                {step.description}
              </p>
            </div>
          </div>
        </StaggerItem>
      ))}
    </StaggerContainer>
  );
}
